///<reference path="../../short-cuts/index.d.ts"/>

module Meevo.Components.Controls {
    "use strict";

    import IDataMaintenanceContext = Meevo.Components.BaseClasses.IDataMaintenanceContext;

    interface IMaintenanceFormCustomButton {
        text: string,
        clickHandler(),
        classNames: string,
        disableRules: () => boolean,
        visibilityRules: () => boolean,
        securityRules: string,
        position: string;
    }

    interface IMaintenanceFormCustomFooterInfo {
        template: string;
        className: string;
        visibilityRules: () => boolean;
        position: string;
    }

    export class MeevoMaintenanceProductForm implements angular.IDirective {

        restrict = "E";
        scope = {
            context: "=",
            searchContext: "=",
            headerContentKey: "@",
            visualState: "=",
            selectedItemId: "=",
            initialEditSection: "=",
            disableCrud: "=",
            shortCutGroup: "=",
            hideSearch: "=",
            showCoBar: "=?",
            closeInterceptor: "&?",
            customButtonsSet: "=?",
            customFooterInfo: "=?",
            templateUrl: "@?",
            headerTemplateUrl: "@?",
            variantDropDownMenu: "=?",
            dashboardTemplateUrl: "@?",
        };

        private window: angular.IWindowService;
        private identityService: Meevo.Components.Common.IIdentityService;
        private dataService: Meevo.Components.Common.ICommonDataService;
        private modalService: Meevo.Components.Modal.IModalService;
        //isSearchGlobal: "=",

        templateUrl = (elem, attrs) => {
            return attrs.templateUrl || 'app/components/controls/product/maintenanceFormProductTemplate.html';
        };

        require = '^form';

        link = (scope: any, element: angular.IAugmentedJQuery, attributes: angular.IAttributes, formCtrl: any) => {
            scope.showEmpDropdown = false;
            scope.showDropdown = false

            // Can override template
            if (!_.isUndefined(scope.templateUrl)) {
                scope.templateUrl = 'app/components/controls/product/maintenanceFormProductTemplate.html';
            }
            // Can override header template
            if (Model.Guard.isNothing(scope.headerTemplateUrl)) {
                scope.headerTemplateUrl = 'app/components/controls/product/maintenanceFormProductHeaderTemplate.html';
            }

            // data maintenance form for searchable entity
            if (_.isUndefined(scope.showCoBar))
                scope.showCoBar = true;
            // Exposes compiled handlebars template
            scope.applySearchResultTemplate = (item: any): string => {
                if (scope.context && scope.context.searchResultTemplateFunction) {
                    return scope.context.searchResultTemplateFunction(item);
                } else {
                    return "";
                }
            }
            scope.applyVariantSearchResultTemplate = (item: any): string => {
                var displayName = item.displayName;
                for (var i = 0; i < item.variantAttributes.length; i++)
                    for (var i2 = 0; i2 < item.variantAttributes[i].displayName.length; i2++)
                        displayName += " " + item.variantAttributes[i].displayName[i2];
                return displayName;
            }

            // non-searchable data maintenance form will not support quick dropdown results
            scope.showMobileMenu = () => {
                if (!scope.mobileMenu) {
                    scope.mobileMenu = true;
                } else {
                    scope.mobileMenu = false;
                }
            }

            scope.showAuditHistory = (auditMenu = false) => {

                Meevo.Model.PurposeEnum.Audit
                let request = {
                    asLocationId: scope.context.asLocationId,
                    itemsPerPage: 30,
                    pageNumber: 0,
                    criteria: {
                        entityId: scope.context.itemId,
                        startDate: moment().subtract(2, "years").toDate(),
                        endDate: moment().toDate(),
                        purpose: Meevo.Model.PurposeEnum.Audit,
                    }
                }
                this.dataService.customMethodData("api/ActivityLog/DataChange/List/", "post", request).then((res) => {
                    scope.auditHistory = res.data;
                    if (auditMenu) {
                        let options: Meevo.Components.Modal.IModalOptions = {
                            templateUrl: "app/components/auditHistory/auditHistory.html",
                            locals: {
                                auditLog: res.data,
                                userId: this.identityService.current().userId,
                                userName: this.identityService.current().userAuthName
                            },
                            controller: "meevo.auditHistory.AuditHistoryController",
                            controllerAs: "auditHistory",
                            clickOutsideToClose: true,
                            bindToController: true
                        }
                        this.modalService.showCustom(options);
                    }
                })
            }


            //scope.checkHasLocal = (): boolean => {

            //    let tempLocalActivity = _.find(scope.searchContext, function (item: any) {
            //        return scope.selectedItemId === item.id
            //    });
            //    if (scope.isSearchGlobal) {
            //        return tempLocalActivity.hasLocalProfile;
            //    }
            //    else {
            //        return;
            //    }

            //}

            scope.submitForm = (): void => {
                angular.forEach(formCtrl, function (value, key) {
                    if (typeof value === 'object' && key !== undefined && value.hasOwnProperty('$modelValue'))
                        formCtrl[key].$dirty = true;
                });

                if (formCtrl.$valid && !formCtrl.$pending) {
                    this.busyService.start();
                    scope.context.save().finally(() => {
                        //scope.context.trackingService.saveTrackingInfo();
                        this.busyService.stop();
                    });
                }
                else if (!formCtrl.$valid) {
                    angular.element(".meevo-maint-center").scrollTop(angular.element("[name='maintenanceForm']").find(".ng-invalid")[0].offsetTop);
                }
            }

            scope.cancel = (): void => {
                scope.context.cancel();
                formCtrl.$setPristine();
            }

            scope.detail = (id: Guid): void => {
                scope.selectedItemId = id;
                // Need to clear this out in case user wants to search from the same context. FOR CLIENT CONTEXT
                if (scope.initialEditSection)
                    scope.initialEditSection = undefined;
                scope.visualState = Model.MaintenanceFormVisualState.Detail;
                scope.showDropdown = false;
            }
            scope.shouldDisplayPluginDashboard = (shouldDisplay) => {
                scope.showAuditHistory();
                scope.displayPluginDashboard = shouldDisplay;
            }
            scope.openAuditModal = () => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/components/auditHistory/auditHistory.html",
                    locals: {
                        auditLog: scope.auditHistory,
                        userId: this.identityService.current().userId,
                        //auditcreatedrecord: entitycreatedresponse.data,
                        userName: this.identityService.current().userAuthName
                    },
                    controller: "meevo.auditHistory.AuditHistoryController",
                    controllerAs: "auditHistory",
                    bindToController: true
                }
                this.modalService.showCustom(options);
            }

            scope.search = (): void => {
                if (angular.isUndefined(scope.closeInterceptor)) {
                    doSearch();
                } else {
                    scope.closeInterceptor()
                        .then(() => {
                            doSearch();
                        })
                }

            }

            scope.closeContext = (): void => {
                if (angular.isUndefined(scope.closeInterceptor)) {
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
                } else {
                    scope.closeInterceptor()
                        .then(() => {
                            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
                        })
                }
            }

            function doSearch() {
                scope.selectedItemId = null;
                scope.visualState = Model.MaintenanceFormVisualState.Search;

                if (scope.context.selectedSection != null && scope.context.selectedSection.model != null)
                    scope.context.selectedSection.model = null;
            }

            scope.$watch(() => {
                return formCtrl.$error;
            }, (newVal) => {
                scope.validationErrorList = newVal;
            }, true)


            if(scope.shortCutGroup) {
                this.shortCutsService.maintenanceFormDirectiveWrapper(scope);
            }

        }

        constructor(private $rootScope: angular.IRootScopeService,
            private $state: angular.ui.IStateService,
            private $document: angular.IDocumentService,
            private busyService: Meevo.Components.Busy.IBusyService, dataService: Meevo.Components.Common.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService, $window: ng.IWindowService, identityService: Meevo.Components.Common.IIdentityService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) {
            this.window = $window;
            this.identityService = identityService;
            this.dataService = dataService;
            this.modalService = modalService;

        }


        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope: angular.IRootScopeService, $state: angular.ui.IStateService,
                $document: angular.IDocumentService, busyService: Meevo.Components.Busy.IBusyService, dataService, modalService, $window, identityService, shortCutsService) => {
                return new MeevoMaintenanceProductForm($rootScope, $state, $document, busyService, dataService, modalService, $window, identityService, shortCutsService);
            };

            directive.$inject = ["$rootScope", "$state", "$document", "meevo.components.busy.BusyService", "meevo.components.common.DataService", "meevo.components.modal.ModalService", "$window", "meevo.components.common.IdentityService", "meevo.components.short-cuts.ShortCutsService"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoMaintenanceProductForm", MeevoMaintenanceProductForm.factory());
}